<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter-no" id="ch-4"><a id="page_17">4</a></h1><a id="page_17">
<p class="para">B<span class="smallcaps">RIDGET DOES NOT STAY</span> in Arnold’s house very long. She tells me she has considered moving from the top floor, where my mother’s bedroom is, to another part of the house, and the place is certainly large enough that you could get quite lost in it. The downstairs rooms, for instance, even though they are no longer occupied by servants but rather by a wine cellar, exercise equipment still in its original packaging, and a “media room” that nobody, so far as I can tell, has ever used, are spacious enough. But it would be a futile gesture. What Arnold exacts for his hospitality is insidious and persistent, and for Bridget remaining under his roof is impossible.</p>
<p class="indent-para">“He keeps asking me how long she has,” she says to Tibor when he calls from Boston. “I try to avoid him but tonight he posted himself outside the bathroom door, waiting for me. It’s like he’s counting down.”</p>
<p class="indent-para">“What did you say to him?” Tibor asks.</p>
<p class="indent-para">“I said that she was stabilizing and might even get better.”</p>
<p class="indent-para">“He can’t believe that.”</p>
<p class="indent-para">“He tried to talk to the doctor, but the doctor can’t abide him and says whatever I ask him to say.”</p>
<p class="indent-para">“But why? Why the subterfuge?”</p>
</a><p class="indent-para"><a id="page_17">“If you have to ask, you don’t understand Arnold,” Bridget says. “If he got the sense that she was about to die, he would taunt her with </a><a id="page_18">it, in his inimitable way rub it in as if it were some sort of weakness on her part. He would make her feel like a fool.”</a></p><a id="page_18">
<p class="indent-para">Tibor listens, may raise an eyebrow, does not pass judgment. “There’s one other thing,” Bridget adds. “He would lose no time telling Mom she was dying, and if she thought it were true she would give up the ghost. It’s hard enough motivating her to eat and talk now. Can you imagine how it would be if she lost whatever remains of her will to live?”</p>
<p class="indent-para">“She knows she’s dying,” Tibor says</p>
<p class="indent-para">“She doesn’t know she’s dying.”</p>
<p class="indent-para">“She knows she’s dying,” he repeats.</p>
<p class="indent-para">“No, that’s not true,” Bridget insists. “And even if it were true, how would you like to have it confirmed in the snide asides of a spouse who wants to discard you?”</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 011_Chapter04.vue?79ec844c